<umkt-card-wrapper
  [title]="'pages.productConfig.title' | i18n"
  [icon]="{ name: 'engrenagem', type: 'mondrian-icons' }"
  [showCheck]="showCheck"
  [loading]="isLoading"
  [loadingText]="loadingText"
  [initiallyOpen]="true"
>
  <div *ngIf="!isEditing" class="pi-container">
    <div *ngIf="configurableProducts.length; else empty">
      <div class="pi-product-item" *ngFor="let item of configurableProducts; let i = index; let last = last">
        <div class="pi-config-header">
          <div class="pi-config-icon">
            <umkt-icon [icon]="item.icon" size="sm"></umkt-icon>
          </div>
          <div class="pi-config-title">
            <h3>{{ item.productName }}</h3>
            <p>{{ item.planName }}</p>
            <span *ngIf="showFreeDomainLabel(item.selectedVariation)" class="pi-free-domain-label">
              {{ 'pages.productConfig.freeDomainLabel' | i18n }}
            </span>
          </div>
          <div class="pi-actions">
            <button
              type="button"
              class="pi-edit-btn"
              (click)="editItem(item.selectedVariation.uuid)"
              *ngIf="!isEditing && i === 0"
            >
              {{ 'pages.productConfig.editButton' | i18n }}
            </button>
          </div>
        </div>
        <div class="pi-domain-info">
          <span class="pi-domain-label">{{
            (item.domainLabel || 'pages.productConfig.domain.notConfigured') | i18n
          }}</span>
          <span class="pi-domain-value">{{ item.domain }}</span>
        </div>
        <div class="pi-divider" *ngIf="!last"></div>
      </div>
    </div>

    <ng-template #empty>
      <div class="pi-empty">{{ 'pages.productConfig.empty' | i18n }}</div>
    </ng-template>
  </div>

  <div *ngIf="isEditing" class="pi-config-mode">
    <p class="pi-description">{{ 'pages.productConfig.description' | i18n }}</p>
    <form [formGroup]="domainConfigForm">
      <div class="pi-batch-config" *ngIf="domainGroups.length > 0">
        <p class="pi-batch-config-description">{{ 'pages.productConfig.batchConfig.title' | i18n }}</p>
        <div class="pi-checkbox-group" *ngFor="let group of domainGroups; let i = index">
          <input
            type="checkbox"
            [id]="'useSameDomain_' + group.type"
            [checked]="domainGroupConfigs[group.type]"
            (change)="onDomainGroupConfigChange(group.type, $event)"
            class="pi-checkbox"
          />
          <label [for]="'useSameDomain_' + group.type" class="pi-checkbox-label">
            {{ 'pages.productConfig.batchConfig.label' | i18n: { count: group.count, label: group.label } }}
          </label>
        </div>
      </div>

      <div class="pi-product-configs" formArrayName="groupConfigs">
        <div class="pi-config-card" *ngFor="let product of configurableProducts; let i = index" [formGroupName]="i">
          <div class="pi-config-header">
            <div class="pi-config-icon">
              <umkt-icon [icon]="product.icon" size="md"></umkt-icon>
            </div>
            <div class="pi-config-title">
              <h3>{{ product.productName }}</h3>
              <p>{{ product.planName }}</p>
              <div *ngIf="showFreeDomainLabel(product.selectedVariation)" class="pi-free-domain-label-container">
                <umkt-icon [icon]="{ name: 'presente', type: 'mondrian-icons' }" size="sm"></umkt-icon>
                {{ 'pages.productConfig.freeDomainLabel' | i18n }}
              </div>
            </div>
          </div>

          <div class="pi-config-options" *ngIf="checkInputVisibility(product.domainFormKey, product.domainFormKey)">
            <div class="pi-radio-group">
              <div class="pi-radio-item">
                <input
                  type="radio"
                  [id]="'newDomain_' + product.domainFormKey"
                  formControlName="domainType"
                  value="new"
                  class="pi-radio"
                  (change)="onDomainTypeChange('new', product.domainFormKey)"
                />
                <label [for]="'newDomain_' + product.domainFormKey" class="pi-radio-label">{{
                  'pages.productConfig.domain.create' | i18n
                }}</label>
              </div>
              <div
                class="pi-radio-item"
                *ngIf="
                  (getUnifiedFormData(product.domainFormKey)?.group === 'microsoft' ||
                    getUnifiedFormData(product.domainFormKey)?.group === 'google' ||
                    getUnifiedFormData(product.domainFormKey)?.group === 'com.br') &&
                  !isExistingDomainPurchaseBlocked(product.selectedVariation.uuid)
                "
              >
                <input
                  type="radio"
                  [id]="'existingDomain_' + product.domainFormKey"
                  formControlName="domainType"
                  value="existing"
                  class="pi-radio"
                  (change)="onDomainTypeChange('existing', product.domainFormKey)"
                />
                <label [for]="'existingDomain_' + product.domainFormKey" class="pi-radio-label">{{
                  'pages.productConfig.domain.existing' | i18n
                }}</label>
              </div>
            </div>

            <div class="pi-domain-input-group">
              <umkt-verify-domain
                formControlName="domain"
                [label]="'pages.productConfig.domain.label' | i18n"
                [domainSuffix]="
                  getDomainSuffixByGroup(
                    getUnifiedFormData(product.domainFormKey)?.group || getProductDomainType(product),
                    getUnifiedFormData(product.domainFormKey)?.domainType
                  )
                "
                [isValid]="domainValidationResults[product.domainFormKey]"
                [feedback]="getVerifyDomainFeedback(product.domainFormKey)"
                [customErrorMessage]="getCustomErrorMessage(product.domainFormKey)"
                (input)="onDomainInput($event, product.domainFormKey)"
              ></umkt-verify-domain>
              <div class="pi-ownership-verification" *ngIf="hasOwnershipManualVerificationError(product.domainFormKey)">
                <p class="pi-ownership-question">
                  {{ 'pages.productConfig.domain.ownershipQuestion' | i18n }}
                </p>
                <div class="pi-ownership-actions">
                  <button
                    type="button"
                    class="pi-ownership-btn pi-ownership-btn--primary"
                    (click)="onConfirmDomainOwnership(product.domainFormKey)"
                  >
                    {{ 'pages.productConfig.domain.ownershipYes' | i18n }}
                  </button>
                  <button
                    type="button"
                    class="pi-ownership-btn pi-ownership-btn--secondary"
                    (click)="onChangeDomainOwnership(product.domainFormKey)"
                  >
                    {{ 'pages.productConfig.domain.ownershipNo' | i18n }}
                  </button>
                </div>
              </div>

              <div
                class="pi-google-domain-warning"
                *ngIf="shouldShowGoogleDomainNotInUseWarning(product.domainFormKey)"
              >
                <div class="pi-google-domain-warning__card">
                  <div class="pi-google-domain-warning__header">
                    <span
                      class="mdn-Icon-triangulo-exclamacao pi-google-domain-warning__icon"
                      aria-hidden="true"
                    ></span>
                    <h4 class="pi-google-domain-warning__title">
                      {{ 'pages.productConfig.domain.googleDomainNotInUseWarningTitle' | i18n }}
                    </h4>
                  </div>
                  <div class="pi-google-domain-warning__ack">
                    <input
                      type="checkbox"
                      class="pi-checkbox"
                      [id]="'googleDomainAck_' + product.domainFormKey"
                      [checked]="isGoogleDomainNotInUseAcknowledged(product.domainFormKey)"
                      (change)="onGoogleDomainNotInUseAcknowledgedChange(product.domainFormKey, $event)"
                    />
                    <label
                      class="pi-google-domain-warning__ack-label"
                      [for]="'googleDomainAck_' + product.domainFormKey"
                    >
                      {{ 'pages.productConfig.domain.googleDomainNotInUseAck' | i18n }}
                    </label>
                  </div>
                </div>
              </div>

              <div
                class="pi-ownership-verification pi-domain-register-verification"
                *ngIf="
                  isDomainRegisterConfirmationPending(product.domainFormKey) &&
                  !isRegistryDomainVariationUuid(product.selectedVariation.uuid)
                "
              >
                <div class="pi-domain-register-feedback">
                  <span class="mdn-Icon-check pi-domain-register-feedback-icon" aria-hidden="true"></span>
                  <div class="pi-domain-register-feedback-content">
                    <h4 class="pi-domain-register-feedback-title">
                      {{ 'pages.productConfig.domain.newDomainAvailableTitle' | i18n }}
                    </h4>
                    <p class="pi-domain-register-feedback-description">
                      {{
                        'pages.productConfig.domain.newDomainAvailableDescription'
                          | i18n: { domain: getCompleteDomainForVariation(product.domainFormKey) }
                      }}
                    </p>
                  </div>
                </div>

                <div
                  class="pi-domain-register-title-row"
                  *ngIf="!isRegistryDomainVariationUuid(product.selectedVariation.uuid)"
                >
                  <p class="pi-domain-register-question">
                    {{ 'pages.productConfig.domain.registerQuestionTitle' | i18n }}
                  </p>
                  <p class="pi-domain-register-price">
                    <span class="pi-domain-register-price-amount">{{ domainRegisterPriceAmount }}</span
                    ><span class="pi-domain-register-price-suffix">{{ domainRegisterPriceSuffix$ | async }}</span>
                  </p>
                </div>

                <p class="pi-domain-register-description">
                  {{ 'pages.productConfig.domain.registerQuestionDescription' | i18n }}
                </p>

                <div class="pi-ownership-actions">
                  <button
                    type="button"
                    class="pi-ownership-btn pi-ownership-btn--primary"
                    (click)="onConfirmDomainRegister()"
                  >
                    {{ 'pages.productConfig.domain.registerConfirm' | i18n }}
                  </button>

                  <button
                    type="button"
                    class="pi-ownership-btn pi-ownership-btn--secondary"
                    (click)="onDeclineDomainRegister()"
                  >
                    {{ 'pages.productConfig.domain.registerDecline' | i18n }}
                  </button>
                </div>
              </div>
            </div>
            <button
              type="button"
              class="pi-check-domain-btn"
              [disabled]="isLoading || isVerifyButtonDisabled(product.domainFormKey)"
              (click)="checkDomainAvailability(product.domainFormKey)"
            >
              {{
                (isLoading ? 'pages.productConfig.domain.verifying' : getButtonTextKey(product.domainFormKey)) | i18n
              }}
            </button>
          </div>
          <div
            class="pi-domain-divider"
            *ngIf="checkInputVisibility(product.domainFormKey, product.domainFormKey)"
          ></div>
        </div>
      </div>

      <div class="pi-config-actions">
        <button type="button" class="btn-outline" *ngIf="isLastStep; else backButton" (click)="cancelEdit()">
          {{ 'shared.buttons.cancel' | i18n }}
        </button>
        <ng-template #backButton>
          <button type="button" class="btn-outline" (click)="previousStep.emit()">
            {{ 'shared.buttons.back' | i18n }}
          </button>
        </ng-template>
        <button
          type="submit"
          class="btn-primary"
          [disabled]="!isFormValid() || !areAllDomainsValid() || isLoading"
          (click)="saveAndContinue()"
        >
          {{ (isLastStep ? 'shared.buttons.save' : 'shared.buttons.continue') | i18n }}
        </button>
      </div>
    </form>
  </div>
</umkt-card-wrapper>

<umkt-domain-authorization-modal
  [isOpen]="showAuthorizationModal"
  [domain]="domainNeedingAuthorization"
  (closeModal)="onCloseAuthorizationModal()"
  (authorize)="onAuthorizeDomain()"
>
</umkt-domain-authorization-modal>

<umkt-domain-authorization-confirmation-modal
  [isOpen]="showAuthorizationConfirmationModal"
  [domain]="domainNeedingAuthorization"
  (confirm)="onConfirmAuthorization()"
>
</umkt-domain-authorization-confirmation-modal>
